type ActionUrlFormData = {
  trigger: string;
  enabled: boolean;
};

type ExistingActionUrl = {
  trigger: string;
  enabled: boolean;
  id?: string;
};

/**
 * Returns true if there is a conflict:
 * another enabled entity with the same trigger already exists.
 */
export function hasTriggerConflict(
  formData: ActionUrlFormData,
  existingList: ExistingActionUrl[],
  options?: {
    excludeId?: string;
  }
): boolean {
  if (!formData.enabled) {
    return false;
  }

  return existingList.some(item => {
    if (!item.enabled) return false;
    if (item.trigger !== formData.trigger) return false;

    if (options?.excludeId && item.id === options.excludeId) {
      return false;
    }

    return true;
  });
}
